import { useEffect } from 'react'
import { isEmpty, omitBy } from 'lodash'
import { useGetJwtTokenQuery } from '../react-query/featurebase/query/use-get-jwt-token-query'

const FEATUREBASE_ORGANIZATION = 'docutools'
const FEATUREBASE_SDK_ID = 'featurebase-sdk'

// Creates the Featurebase queue stub and injects the SDK once.
// Calls made before the SDK finishes loading are queued and replayed by it.
const loadFeaturebaseSdk = () => {
  const win = window

  if (typeof win.Featurebase !== 'function') {
    win.Featurebase = function () {
      ;(win.Featurebase.q = win.Featurebase.q || []).push(arguments)
    }
  }

  if (!document.getElementById(FEATUREBASE_SDK_ID)) {
    const script = document.createElement('script')
    script.src = 'https://do.featurebase.app/js/sdk.js'
    script.id = FEATUREBASE_SDK_ID
    script.async = true
    document.body.appendChild(script)
  }
}

const FeaturebaseIntegration = ({ user }) => {
  const { data: jwtToken } = useGetJwtTokenQuery({ enabled: !isEmpty(user) })

  useEffect(() => {
    if (isEmpty(user) || !jwtToken?.jwt) return

    loadFeaturebaseSdk()

    const customFields = {
      jobTitle: user.jobTitle,
      plan: user.subscriptionInfo?.tier?.name,
      phone: user.phone,
      city: user.city,
      zip: user.zip,
      owner: user.owner ? 'true' : 'false'
    }

    // Remove null fields or empty
    const cleanedCustomFields = omitBy(
      customFields,
      (value) => value == null || value === ''
    )

    // Identity is verified by the backend-signed JWT (featurebaseJwt).
    // The plain attributes below are only trusted by Featurebase while
    // enforcement is off; once it is on, the JWT payload is the source of truth.
    window.Featurebase(
      'identify',
      {
        organization: FEATUREBASE_ORGANIZATION,
        featurebaseJwt: jwtToken.jwt,
        locale: user.settings.language,
        email: user.email,
        name: `${user.firstName} ${user.lastName}`,
        id: user.userId,
        customFields: cleanedCustomFields,
        companies: [
          {
            id: user.organisationId,
            name: user.organisationName ?? ''
          }
        ]
      },
      (err) => {
        if (err) console.error('Featurebase Error:', err)
      }
    )
  }, [user, jwtToken])

  return null
}

export default FeaturebaseIntegration
